import React from 'react';

export default function Contact(): React.JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-6 py-16">
      <div className="rounded-2xl border border-mcc-lightest/60 bg-white p-8 md:p-12 shadow-sm">
        <h1 className="text-3xl font-bold text-mcc-darkest md:text-4xl">Contact Us</h1>
        <p className="mt-4 text-slate-600 text-lg">
          Have questions or need assistance? Reach out to our care team directly at{' '}
          <a href="mailto:info@myconnectivecare.com" className="text-mcc-neutral font-medium underline hover:text-mcc-darkest">
            info@myconnectivecare.com
          </a>.
        </p>
      </div>
    </div>
  );
}